import { render, staticRenderFns } from "./EntryMessageRegisterForm.vue?vue&type=template&id=6d2a7cb4"
import script from "./EntryMessageRegisterForm.vue?vue&type=script&lang=js"
export * from "./EntryMessageRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports